export const products = {
    hotels: 1,
    flights: 2,
    holidays: 4,
    transfers: 8,
    carHire: 16,
    marhaba: 32,
    attractions: 64,
    parking: 128,
    insurance: 256
};

export function isProductSupported(product) {
    // eslint-disable-next-line no-bitwise
    return (TRPCONFIG.Domain.SupportedProducts & product) > 0;
}
